import { TQueryParams } from '@/domain/Pages.domain';
import { ReadonlyURLSearchParams } from 'next/navigation';

const QUERY_PARAMS_KEYS = ['from', 'to', 'promocode'];

export const getQueryParams = (query: ReadonlyURLSearchParams | null): TQueryParams => {
    if (!query) {
        return {};
    }
    const res = QUERY_PARAMS_KEYS.map((name) => [name, query.get(name)]).filter(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ([_, value]) => value
    );

    return Object.fromEntries(res);
};
